//src/ui/Skeleton.jsx
import "./skeleton.css";
const Skeleton = ({ className = "", style = {} }) => {
  return <div className={`skeleton ${className}`.trim()} style={style} />;
};

export default Skeleton;
